import { fontSizes } from '../../../../constants/constants';
import dynamicfunction from '../../../../utils/dynamicfunction';
import { ErrorText, RadioButton, RowView, Text } from '../index';
import CustomInput from '../../../../components/CustomInput';
const NonUsFinancialThen = ({
  getContent,
  values,
  setFieldValue,
  setFieldError,
  setFieldTouched,
  touched,
  optionsYesOrNO,
  errors,
  formatGIIN,
}) => {
  const { TextWeight } = dynamicfunction();

  return (
    <>
      <div className='pt-3 sm:pt-5'>
        <Text
          text={getContent('if_non_us_financial_then')}
          size={fontSizes.h18}
          isTruncate={false}
          weight={TextWeight.medium}
          className='block'
          isRequired={true}
        />
      </div>
      <RowView className='pt-3 sm:pt-5' isResponsive>
        <div className='w-full'>
          <RadioButton
            label={getContent('are_you_ksa_financial_institution')}
            value={values?.ksaFinancialInstitution}
            onChange={(e) => {
              setFieldValue('ksaFinancialInstitution', e);
              setFieldTouched('ksaFinancialInstitution', false);
            }}
            options={optionsYesOrNO}
            required={false}
          />
          <ErrorText text={getContent(touched?.ksaFinancialInstitution ? errors?.ksaFinancialInstitution : '')} />
        </div>
      </RowView>
      {Number(values.ksaFinancialInstitution) === 1 && (
        <>
          <div className='pt-3 sm:pt-5'>
            <CustomInput
              isRounded
              isRequired={true}
              label={getContent('giin')}
              value={formatGIIN(values?.giinKsaFinancialInstitution)}
              onChange={(e) => {
                setFieldValue('giinKsaFinancialInstitution', formatGIIN(e.target.value));
                setFieldTouched('giinKsaFinancialInstitution', true, false);
              }}
              maxLength={19}
              errorMessage={getContent(touched?.giinKsaFinancialInstitution ? errors?.giinKsaFinancialInstitution : '')}
            />
          </div>
          <div className='pt-3 sm:pt-5'>
            <CustomInput
              isRounded
              label={getContent('state_reason_in_space_provided')}
              value={values?.reasonProvidedForNotHavingGiin}
              onChange={(e) => {
                setFieldValue('reasonProvidedForNotHavingGiin', e.target.value);
                setFieldTouched('reasonProvidedForNotHavingGiin', true, false);
              }}
              isRequired={false}
              labelDivClass={"h-12 sm:h-6"}
              placeholder={getContent('enter_reason')}
              errorMessage={getContent(touched?.reasonProvidedForNotHavingGiin ? errors?.reasonProvidedForNotHavingGiin : '')}
            />
          </div>
        </>
      )}
      <RowView className='pt-3 sm:pt-5' isResponsive>
        <div className='w-full'>
          <RadioButton
            label={getContent('are_you_participating_financial_institution')}
            value={values?.participatingFinancialInstitution}
            onChange={(e) => {
              setFieldValue('participatingFinancialInstitution', e);
              setFieldTouched('participatingFinancialInstitution', false);
            }}
            options={optionsYesOrNO}
            required={false}
          />
          <ErrorText
            text={getContent(touched?.participatingFinancialInstitution ? errors?.participatingFinancialInstitution : '')}
          />
        </div>
      </RowView>
      {
        Number(values?.participatingFinancialInstitution) === 1 && (
          <div className='pt-3 sm:pt-5'>
            <CustomInput
              isRounded
              isRequired={true}
              label={getContent('giin')}
              value={formatGIIN(values?.giinParticipatingFinancialInstitution)}
              onChange={(e) => {
                setFieldValue(
                  'giinParticipatingFinancialInstitution',
                  formatGIIN(e.target.value)
                );
                setFieldTouched('giinParticipatingFinancialInstitution', true, false);
              }}
              maxLength={19}
              errorMessage={getContent(
                touched?.giinParticipatingFinancialInstitution ? errors?.giinParticipatingFinancialInstitution : ''
              )}
            />
          </div>
        )
      }
      <RowView className='pt-3 sm:pt-5' isResponsive>
        <div className='w-full'>
          <RadioButton
            label={getContent('are_you_registered_deemed_compliant')}
            value={values?.registeredDeemedCompliantFinancialInstitution}
            onChange={(e) => {
              setFieldValue('registeredDeemedCompliantFinancialInstitution', e);
              setFieldTouched('registeredDeemedCompliantFinancialInstitution', false);
            }}
            options={optionsYesOrNO}
            required={false}
          />
          <ErrorText
            text={getContent(
              touched?.registeredDeemedCompliantFinancialInstitution ? errors?.registeredDeemedCompliantFinancialInstitution : ''
            )}
          />
        </div>
      </RowView>
      {Number(values?.registeredDeemedCompliantFinancialInstitution) === 1 && (
        <>
          <RowView className='pt-3 sm:pt-5' isResponsive>
            <div className='w-full'>
              <RadioButton
                label={getContent('local_ffi')}
                value={values?.localFfi}
                onChange={(e) => {
                  setFieldValue('localFfi', e);
                  setFieldTouched('localFfi', false);
                }}
                options={optionsYesOrNO}
                required={false}
              />
              <ErrorText text={getContent(touched?.localFfi ? errors?.localFfi : '')} />
            </div>
            <div className='w-full'>
              <RadioButton
                label={getContent('non_reporting_member_of_pffi')}
                value={values?.nonReportingMemberPffiGroup}
                onChange={(e) => {
                  setFieldValue('nonReportingMemberPffiGroup', e);
                  setFieldTouched('nonReportingMemberPffiGroup', false);
                }}
                options={optionsYesOrNO}
                required={false}
              />
              <ErrorText text={getContent(touched?.nonReportingMemberPffiGroup ? errors?.nonReportingMemberPffiGroup : '')} />
            </div>
            <div className='w-full'>
              <RadioButton
                label={getContent('qualified_collective_investment_vehicles')}
                value={values?.qualifiedCollectiveInvestmentVehicles}
                onChange={(e) => {
                  setFieldValue('qualifiedCollectiveInvestmentVehicles', e);
                  setFieldTouched('qualifiedCollectiveInvestmentVehicles', false);
                }}
                options={optionsYesOrNO}
                required={false}
              />
              <ErrorText
                text={getContent(touched?.qualifiedCollectiveInvestmentVehicles ? errors?.qualifiedCollectiveInvestmentVehicles : '')}
              />
            </div>
          </RowView>
          <RowView className='pt-3 sm:pt-5' isResponsive>
            <div className='w-full'>
              <RadioButton
                label={getContent('restricted_fund')}
                value={values?.restrictedFunds}
                onChange={(e) => {
                  setFieldValue('restrictedFunds', e);
                  setFieldTouched('restrictedFunds', false);
                }}
                options={optionsYesOrNO}
                required={false}
              />
              <ErrorText text={getContent(touched?.restrictedFunds ? errors?.restrictedFunds : '')} />
            </div>
            <div className='w-full'>
              <RadioButton
                label={getContent('qualified_credit_card_issuer')}
                value={values?.qualifiedCreditCardIssuers}
                onChange={(e) => {
                  setFieldValue('qualifiedCreditCardIssuers', e);
                  setFieldTouched('qualifiedCreditCardIssuers', false);
                }}
                options={optionsYesOrNO}
                required={false}
              />
              <ErrorText text={getContent(touched?.qualifiedCreditCardIssuers ? errors?.qualifiedCreditCardIssuers : '')} />
            </div>
            <div className='w-full'>
              <RadioButton
                label={getContent('sponsored_investement_entities')}
                value={values?.sponsoredInvestmentEntities}
                onChange={(e) => {
                  setFieldValue('sponsoredInvestmentEntities', e);
                  setFieldTouched('sponsoredInvestmentEntities', false);
                }}
                options={optionsYesOrNO}
                required={false}
              />
              <ErrorText text={getContent(touched?.sponsoredInvestmentEntities ? errors?.sponsoredInvestmentEntities : '')} />
            </div>
          </RowView>
          <RowView className='pt-3 sm:pt-5' isResponsive>
            <div className='w-full'>
              <RadioButton
                label={getContent('sponsored_controlled_foreign_corporation')}
                value={values?.sponsoredControlledForeignCorporation}
                onChange={(e) => {
                  setFieldValue('sponsoredControlledForeignCorporation', e);
                  setFieldTouched('sponsoredControlledForeignCorporation', false);
                }}
                options={optionsYesOrNO}
                required={false}
              />
              <ErrorText
                text={getContent(touched?.sponsoredControlledForeignCorporation ? errors?.sponsoredControlledForeignCorporation : '')}
              />
            </div>
          </RowView>
          {Number(values.sponsoredControlledForeignCorporation) === 1 && (
            <div className='pt-3 sm:pt-5'>
              <CustomInput
                isRounded
                isRequired={true}
                label={getContent('giin')}
                value={formatGIIN(
                  values?.giinSponsoredControlledForeignCorporation
                )}
                onChange={(e) => {
                  setFieldValue(
                    'giinSponsoredControlledForeignCorporation',
                    formatGIIN(e.target.value)
                  );
                  setFieldTouched('giinSponsoredControlledForeignCorporation', true, false);
                }}
                maxLength={19}
                errorMessage={getContent(
                  touched?.giinSponsoredControlledForeignCorporation ? errors?.giinSponsoredControlledForeignCorporation : ''
                )}
              />
            </div>
          )}
        </>
      )}
      <RowView className='pt-3 sm:pt-5' isResponsive>
        <div className='w-full'>
          <RadioButton
            label={getContent('are_you_certified_deemed_compliant')}
            value={values?.certifiedDeemedCompliantFinancialInstitution}
            onChange={(e) => {
              setFieldValue('certifiedDeemedCompliantFinancialInstitution', e);
              setFieldTouched('certifiedDeemedCompliantFinancialInstitution', false);
            }}
            options={optionsYesOrNO}
            required={false}
          />
          <ErrorText
            text={getContent(
              touched?.certifiedDeemedCompliantFinancialInstitution ? errors?.certifiedDeemedCompliantFinancialInstitution : ''
            )}
          />
        </div>
      </RowView>
      {Number(values?.certifiedDeemedCompliantFinancialInstitution) === 1 && (<>
        <RowView className='pt-3 sm:pt-5' isResponsive>
          <div className='w-full'>
            <RadioButton
              label={getContent('non_registering_local_bank')}
              value={values?.nonRegisteringLocalBank}
              onChange={(e) => {
                setFieldValue('nonRegisteringLocalBank', e);
                setFieldTouched('nonRegisteringLocalBank', false);
              }}
              options={optionsYesOrNO}
              required={false}
            />
            <ErrorText text={getContent(touched?.nonRegisteringLocalBank ? errors?.nonRegisteringLocalBank : '')} />
          </div>
          <div className='w-full'>
            <RadioButton
              label={getContent('ffi_with_only_low_values')}
              value={values?.ffiWithOnlyLowValueAccounts}
              onChange={(e) => {
                setFieldValue('ffiWithOnlyLowValueAccounts', e);
                setFieldTouched('ffiWithOnlyLowValueAccounts', false);
              }}
              options={optionsYesOrNO}
              required={false}
            />
            <ErrorText text={getContent(touched?.ffiWithOnlyLowValueAccounts ? errors?.ffiWithOnlyLowValueAccounts : '')} />
          </div>

          <div className='w-full'>
            <RadioButton
              label={getContent('sponsored_closely_held_investment')}
              value={values?.sponsoredCloselyHeldInvestmentVehicles}
              onChange={(e) => {
                setFieldValue('sponsoredCloselyHeldInvestmentVehicles', e);
                setFieldTouched('sponsoredCloselyHeldInvestmentVehicles', false);
              }}
              options={optionsYesOrNO}
              required={false}
            />
            <ErrorText
              text={getContent(touched?.sponsoredCloselyHeldInvestmentVehicles ? errors?.sponsoredCloselyHeldInvestmentVehicles : '')}
            />
          </div>
        </RowView>

        <RowView className='pt-3 sm:pt-5' isResponsive>
          <div className='w-full'>
            <RadioButton
              label={getContent('limitted_life_debt_invesment')}
              value={values?.limitedLifeDebtInvestmentEntities}
              onChange={(e) => {
                setFieldValue('limitedLifeDebtInvestmentEntities', e);
                setFieldTouched('limitedLifeDebtInvestmentEntities', false);
              }}
              options={optionsYesOrNO}
              required={false}
            />
            <ErrorText
              text={getContent(touched?.limitedLifeDebtInvestmentEntities ? errors?.limitedLifeDebtInvestmentEntities : '')}
            />
          </div>
          <div className='w-full'>
            <RadioButton
              label={getContent('investment_advisor')}
              value={values?.investmentAdvisorsAndInvestmentManagers}
              onChange={(e) => {
                setFieldValue('investmentAdvisorsAndInvestmentManagers', e);
                setFieldTouched('investmentAdvisorsAndInvestmentManagers', false);
              }}
              options={optionsYesOrNO}
              required={false}
            />
            <ErrorText
              text={getContent(touched?.investmentAdvisorsAndInvestmentManagers ? errors?.investmentAdvisorsAndInvestmentManagers : '')}
            />
          </div>
          <div className='w-full'>
            <RadioButton
              label={getContent('owner_documented_ffis')}
              value={values?.ownerDocumentedFfis}
              onChange={(e) => {
                setFieldValue('ownerDocumentedFfis', e);
                setFieldTouched('ownerDocumentedFfis', false);
              }}
              options={optionsYesOrNO}
              required={false}
            />
            <ErrorText text={getContent(touched?.ownerDocumentedFfis ? errors?.ownerDocumentedFfis : '')} />
          </div>
        </RowView>
        <div className='w-full pt-3 sm:pt-5'>
          <RadioButton
            label={getContent('non_reporting_ffi_please_provide')}
            value={values?.nonReportingFfiProvideTheType}
            onChange={(e) => {
              setFieldValue('nonReportingFfiProvideTheType', e);
              setFieldTouched('nonReportingFfiProvideTheType', false);
            }}
            options={optionsYesOrNO}
            required={false}
          />
          <ErrorText text={getContent(touched?.nonReportingFfiProvideTheType ? errors?.nonReportingFfiProvideTheType : '')} />
        </div>
      </>)}

      <RowView className='pt-3 sm:pt-5' isResponsive>
        <div className='w-full'>
          <RadioButton
            label={getContent('are_you_non_participating_fi')}
            value={values?.nonParticipatingFinancialInstitution}
            onChange={(e) => {
              setFieldValue('nonParticipatingFinancialInstitution', e);
              setFieldTouched('nonParticipatingFinancialInstitution', false);
            }}
            options={optionsYesOrNO}
            required={false}
          />
          <ErrorText
            text={getContent(touched?.nonParticipatingFinancialInstitution ? errors?.nonParticipatingFinancialInstitution : '')}
          />
        </div>
        <div className='lg:w-full hidden lg:block'></div>
      </RowView>

      <RowView className='pt-3 sm:pt-5' isResponsive>
        <div className='w-full'>
          <RadioButton
            label={getContent('are_you_trustee_documented_trust')}
            value={values?.trusteeDocumentedTrust}
            onChange={(e) => {
              setFieldValue('trusteeDocumentedTrust', e);
              setFieldTouched('trusteeDocumentedTrust', false);
            }}
            options={optionsYesOrNO}
            required={false}
          />
          <ErrorText text={getContent(touched?.trusteeDocumentedTrust ? errors?.trusteeDocumentedTrust : '')} />
        </div>
      </RowView>
      {Number(values.trusteeDocumentedTrust) === 1 && (
        <RowView className='pt-3 gap-7 sm:pt-5' isResponsive>
          <CustomInput
            isRounded
            label={getContent('trustees')}
            value={values?.trusteesTrusteeDocumentedTrust}
            onChange={(e) => {
              setFieldValue('trusteesTrusteeDocumentedTrust', e.target.value);
              setFieldTouched('trusteesTrusteeDocumentedTrust', true, false);
            }}
            isRequired={false}
            placeholder={getContent('placeholder_trustees')}
            errorMessage={getContent(touched?.trusteesTrusteeDocumentedTrust ? errors?.trusteesTrusteeDocumentedTrust : '')}
          />
          <CustomInput
            isRounded
            label={getContent('trustees_giin')}
            value={formatGIIN(values?.trusteesGiinTrusteeDocumentedTrust)}
            onChange={(e) => {
              setFieldValue(
                'trusteesGiinTrusteeDocumentedTrust',
                formatGIIN(e.target.value)
              );
              setFieldTouched('trusteesGiinTrusteeDocumentedTrust', true, false);
            }}
            maxLength={19}
            isRequired={false}
            placeholder={getContent('placeholder_trustees_giin')}
            errorMessage={getContent(
              touched?.trusteesGiinTrusteeDocumentedTrust ? errors?.trusteesGiinTrusteeDocumentedTrust : ''
            )}
          />
        </RowView>
      )}
    </>
  );
};
export default NonUsFinancialThen;
